<mat-select [(ngModel)]="value" #select (closed)="selectClose($event)" panelWidth="215px"
  disableRipple="true"
  [panelClass]="{sizes: true, hasExtras: extraOptions && extraOptions.length > 0 || range.max < 1}">
  <mat-select-trigger>
    {{ value | size | inches }}
  </mat-select-trigger>
  @for (extraOption of extraOptions; track extraOption.value + extraOption.text) {
    <mat-option [value]="extraOption.value">
      @if (extraOption.text) {
        {{ extraOption.text}}
      }
      @if (!extraOption.text) {
        {{ extraOption.value | size: (range.max >= 1 ? '' : 'multichar') | inches }}
      }
      @if (extraOption.extraText) {
        <span class="mat-option-extra-text">{{ extraOption.extraText }}</span>
      }
    </mat-option>
  }
  @if (extraOptions && extraOptions.length > 0) {
    <mat-divider></mat-divider>
  }
  @for (size of sizes; track size.value) {
    <mat-option [value]="size.value" [disabled]="size.value < range.min"
      [style.opacity]="size.value === 0 ? 0 : 1"
                [ngClass]="{'tall': firstAvailableFractionForSize(size.value) && this.fractions.length > 8,
                            'not-active-size': size !== activeSize}">
      {{ size.value | size: (range.max >= 1 ? '' : 'multichar') | inches }}
    </mat-option>
    @if (size.value >= 1 && firstAvailableFractionForSize(size.value)) {
      @if (size === activeSize || size === selectedSize) {
        <mat-optgroup
          [style.opacity]="size !== activeSize ? 0 : 1"
          [ngClass]="{'tall': firstAvailableFractionForSize(size.value) && this.fractions.length > 8}">
          @for (frac of fractions; track frac) {
            <mat-option class="frac" [value]="size.value + frac"
              [disabled]="(size.value !== 0 && size.value < 1) || size.value + frac < range.min || size.value + frac > range.max">
              {{ frac | size }}
            </mat-option>
          }
        </mat-optgroup>
      }
      @if (size !== activeSize) {
        <div class="mat-mdc-option fractions-activator" (click)="activate(size)"
          [ngClass]="{'tall': firstAvailableFractionForSize(size.value) && this.fractions.length > 8}"
          >
          <span>…</span>
        </div>
      }
    }
  }
</mat-select>
